var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1302 4.79753H1.26628V9.22951C1.26628 11.6772 3.25055 13.6615 5.69827 13.6615C8.14598 13.6615 10.1302 11.6772 10.1302 9.22952V4.79753ZM0 3.53125V9.22951C0 12.3766 2.5512 14.9278 5.69827 14.9278C8.84533 14.9278 11.3965 12.3766 11.3965 9.22952V3.53125H0Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79688 0.050293C4.32139 0.050293 4.74659 0.475493 4.74659 1V3.53257C4.74659 4.05708 4.32139 4.48228 3.79688 4.48228C3.27237 4.48228 2.84717 4.05708 2.84717 3.53257V1C2.84717 0.475493 3.27237 0.050293 3.79688 0.050293Z",
    fill: "#313131"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60157 0.050293C8.12608 0.050293 8.55128 0.475493 8.55128 1V3.53257C8.55128 4.05708 8.12608 4.48228 7.60157 4.48228C7.07706 4.48228 6.65186 4.05708 6.65186 3.53257V1C6.65186 0.475493 7.07706 0.050293 7.60157 0.050293Z",
    fill: "#313131"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.05089 5.61479C8.29815 5.86205 8.29815 6.26293 8.05089 6.51019L6.59917 7.96191H7.6032C7.85928 7.96191 8.09014 8.11617 8.18814 8.35276C8.28614 8.58935 8.23197 8.86168 8.05089 9.04275L4.88519 12.2085C4.63793 12.4557 4.23705 12.4557 3.98979 12.2085C3.74254 11.9612 3.74254 11.5603 3.98979 11.3131L6.07466 9.2282H5.07063C4.81455 9.2282 4.58369 9.07394 4.48569 8.83735C4.38769 8.60076 4.44186 8.32843 4.62293 8.14736L7.1555 5.61479C7.40275 5.36754 7.80364 5.36754 8.05089 5.61479Z",
    fill: "#313131"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79688 13.6641H7.59572V15.5635C7.59572 16.6125 6.74532 17.4629 5.6963 17.4629V17.4629C4.64728 17.4629 3.79688 16.6125 3.79688 15.5635V13.6641Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.59e2c45f78692e40372480192c8551ff.svg";
export { ForwardRef as ReactComponent };